import { useDispatch } from 'react-redux';
import { searchWooDocuments } from 'api/algolia';
import { setIsLoading, setWooRequests, setWooRequestsCount } from 'redux/stores/woo-requests';
import { ISortOption } from 'components/sort';
import { WOO_REQUEST_OVERVIEW_LIMIT } from '../woo-document-overview';

type FetchWooDocuments = (
	page: number,
	sort: ISortOption,
	searchValue: string,
	categoryIds: string[],
	startDate?: Date,
	endDate?: Date,
	locale?: string
) => Promise<void>;

export type UseWooDocumentsDataReturn = {
	fetchWooDocuments: FetchWooDocuments;
};

export const useWooDocumentsData = (): UseWooDocumentsDataReturn => {
	const dispatch = useDispatch();

	const fetchWooDocuments: FetchWooDocuments = async (
		page,
		sort,
		searchValue,
		categoryIds,
		startDate,
		endDate,
		locale
	): Promise<void> => {
		dispatch(setIsLoading(true));

		try {
			const { results: woo, total } = await searchWooDocuments(
				searchValue,
				{
					categoryIds: categoryIds ?? [],
					startDate,
					endDate
				},
				{ sort: sort?.id === 'asc' ? 'asc' : 'desc', page, limit: WOO_REQUEST_OVERVIEW_LIMIT, locale }
			);

			dispatch(setWooRequests(woo));
			dispatch(setWooRequestsCount(total));
		} catch {
			dispatch(setWooRequests([]));
			dispatch(setWooRequestsCount(0));
		}

		dispatch(setIsLoading(false));
	};

	return {
		fetchWooDocuments
	};
};
